export default __webpack_public_path__ + "static/media/google_play_ru.43ec78f9.png";